import { createContext } from 'react';

import { IAuthenticatedUser } from 'common/src/types/interfaces';

import { IAuthorizationContext } from './IAuthorizationContext';

export interface AuthContextType extends IAuthorizationContext {
  changePassword: (newPassword: string) => Promise<boolean>;
  getUser: () => IAuthenticatedUser | undefined;
  getUserPicture: () => any;
  googleLogin: (idToken: string) => Promise<boolean>;
  hasOrgSwitchingAccess: () => boolean;
  initiateEnterpriseSSOLogin: (string) => Promise<string | null>;
  isAuthenticated: () => boolean;
  isPasswordExpired: () => boolean;
  isReadyForAuthorization: () => boolean;
  login: (email: string, password: string) => Promise<boolean>;
  logout: () => void;
  microsoftLogin: (accessToken: string) => Promise<boolean>;
  refreshUser: () => Promise<void>;
  signup: (uid: string, password: string) => Promise<boolean>;
  ssoAuthLogin: (jwt: string) => Promise<boolean>;
  switchOrganization: (orgId: string) => Promise<void>;
  tokenLogin: (jwt: string) => Promise<boolean>;
  verifyUserAccountProvider: () => Promise<any>;
  verifyWorkosEmail: (code: string) => Promise<boolean>;
}

const AuthContext = createContext<AuthContextType>(null!);

export default AuthContext;
